import { api } from './api.js';

export const notificationAPI = {
  poll: async (params = {}) => {
    try {
      const response = await api.get('/notification/poll', { params });
      return response.data;
    } catch (error) {
      return null;
    }
  },

  publish: async (data) => {
    try {
      const response = await api.post('/notification/publish', data);
      return response.data;
    } catch (error) {
      return null;
    }
  },

  resendEmail: async (configId) => {
    const response = await api.post('/notification/resendEmail', { config_id: configId });
    return response.data;
  }
};


